import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ShieldCheck, Truck, BadgeIndianRupee } from "lucide-react";
import { LOGO_URL } from "../lib/api";

export default function Footer() {
  return (
    <footer className="bg-brand-navy text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="bg-white rounded-2xl inline-flex px-5 py-3">
            <img src={LOGO_URL} alt="Vearn" className="h-10 w-auto" />
          </div>
          <p className="mt-6 text-white/60 text-sm leading-relaxed max-w-sm">
            Shop. Earn. Grow Together. Vearn brings premium products to your doorstep
            and a Partner Program that grows with your network.
          </p>
          <div className="mt-8 flex flex-col gap-3 text-sm text-white/70">
            <span className="flex items-center gap-3"><MapPin className="h-4 w-4 text-brand-cyan" /> Coimbatore, Tamil Nadu, India</span>
            <a href="mailto:support@vearn.shop" data-testid="footer-email" className="flex items-center gap-3 hover:text-brand-cyan transition-colors">
              <Mail className="h-4 w-4 text-brand-cyan" /> support@vearn.shop
            </a>
            <a href="tel:+919790007557" data-testid="footer-phone" className="flex items-center gap-3 hover:text-brand-cyan transition-colors">
              <Phone className="h-4 w-4 text-brand-cyan" /> +91 97900 07557
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 font-semibold">Shop</h4>
          <div className="mt-5 flex flex-col gap-3 text-sm">
            <Link to="/shop" className="text-white/70 hover:text-brand-cyan transition-colors">All Products</Link>
            <Link to="/shop?category=Electronics" className="text-white/70 hover:text-brand-cyan transition-colors">Electronics</Link>
            <Link to="/shop?category=Fashion" className="text-white/70 hover:text-brand-cyan transition-colors">Fashion</Link>
            <Link to="/shop?category=Beauty" className="text-white/70 hover:text-brand-cyan transition-colors">Beauty</Link>
            <Link to="/track" className="text-white/70 hover:text-brand-cyan transition-colors">Track Order</Link>
            <Link to="/partner" className="text-white/70 hover:text-brand-cyan transition-colors">Become a Partner</Link>
          </div>
        </div>
        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 font-semibold">Why Vearn</h4>
          <div className="mt-5 flex flex-col gap-4 text-sm text-white/70">
            <span className="flex items-start gap-3"><Truck className="h-4 w-4 mt-0.5 text-brand-cyan shrink-0" /> Free shipping on orders above ₹999 across India</span>
            <span className="flex items-start gap-3"><ShieldCheck className="h-4 w-4 mt-0.5 text-brand-cyan shrink-0" /> Secure payments powered by Cashfree</span>
            <span className="flex items-start gap-3"><BadgeIndianRupee className="h-4 w-4 mt-0.5 text-brand-cyan shrink-0" /> Partner income paid through verified manual transfers</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Vearn E-Commerce. All rights reserved.</span>
          <span>vearn.shop — Shop • Earn • Grow Together</span>
        </div>
      </div>
    </footer>
  );
}
